import { useState, useEffect } from 'react';

export const useOmniBoxWidth = () => {
  const [containerWidth, setContainerWidth] = useState<string>('640px');

  useEffect(() => {
    const calculateWidth = () => {
      const viewportWidth = window.innerWidth;
      const horizontalPadding = 32; // 16px on each side
      const availableWidth = viewportWidth - horizontalPadding;

      // Define our constraints
      const minWidth = 460;
      const maxWidth = 640;

      if (availableWidth <= minWidth) {
        // For very small screens, use full available width
        setContainerWidth(`calc(100% - ${horizontalPadding}px)`);
      } else if (availableWidth >= maxWidth) {
        // For large screens, cap at max width
        setContainerWidth(`${maxWidth}px`);
      } else {
        // For medium screens, use available width
        setContainerWidth(`${availableWidth}px`);
      }
    };

    // Calculate initial width
    calculateWidth();

    // Recalculate on window resize
    window.addEventListener('resize', calculateWidth);
    return () => window.removeEventListener('resize', calculateWidth);
  }, []);

  // Return both the computed width and the constraints for consistent styling
  return {
    width: containerWidth,
    maxWidth: 640,
    minWidth: 'min(460px, calc(100% - 32px))',
  };
};
